module.exports = __webpack_public_path__ + "static/media/sunrise.81c6c187.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/sunrise.png
// module id = 45
// module chunks = 1